"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCustomTab = exports.isOptionTab = exports.useVisibleTab = exports.getNavItems = exports.CUSTOM_HREF = exports.OPTION_HREF = void 0;
const react_1 = require("react");
exports.OPTION_HREF = '#option';
exports.CUSTOM_HREF = '#custom';
const DEFAULT_HREF = exports.OPTION_HREF;
function getNavItems({ isDisabled, itemsLabel, shouldShowCustomTab, }) {
    if (shouldShowCustomTab) {
        return [
            { href: exports.OPTION_HREF, text: itemsLabel, isDisabled },
            { href: exports.CUSTOM_HREF, text: 'Custom', isDisabled },
        ];
    }
    return [{ href: exports.OPTION_HREF, text: itemsLabel, isDisabled }];
}
exports.getNavItems = getNavItems;
function useVisibleTab({ hasCustomValue, }) {
    const [visibleTab, setVisibleTab] = react_1.useState(hasCustomValue ? exports.CUSTOM_HREF : DEFAULT_HREF);
    return {
        setVisibleTab,
        visibleTab,
    };
}
exports.useVisibleTab = useVisibleTab;
function isOptionTab(href) {
    return href === exports.OPTION_HREF;
}
exports.isOptionTab = isOptionTab;
function isCustomTab(href) {
    return href === exports.CUSTOM_HREF;
}
exports.isCustomTab = isCustomTab;
